import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';

export const handleNotEnoughCredits = ({
    openPaidDownloadUpsellModal,
}: {
    openPaidDownloadUpsellModal: any;
}) => {
    openPaidDownloadUpsellModal({
        interactionSource: InteractionSource.Automatic,
    });
};
